<script setup>
import { computed } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { usePointsStore } from '@/stores/points'
import { useTripsCarStore } from '@/stores/trips'
import driveAssessment  from '@/helpers/driveAssessment'
import makeTimeStamp    from '@/helpers/makeTimeStamp'

const translaterStore   = useTranslaterStore()
const pointsStore       = usePointsStore()
const tripsCarStore     = useTripsCarStore()

const props = defineProps({
    uuid: {
        type: String,
        required: true
    }
})

const getTranslate  = computed(() => translaterStore.getTranslate)
const states        = computed(() => pointsStore.carState)
const tripMonth     = computed(() => tripsCarStore.tripMonth)

// @TODO: Это что-то прикольное. Надо бы разобраться почему мы это скрыли. 
// function carIsMooving() {
//     if(this.carStartMoovingTS && this.carStopMoovingTS) {
//         return this.carStopMoovingTS < this.carStartMoovingTS
//     } else if(!this.carStartMoovingTS && this.carStopMoovingTS) {
//         return false
//     } else if(this.carStartMoovingTS && !this.carStopMoovingTS) {
//         return true
//     }
//     return true
// }

const engineOnTS = computed(() => {
    return states.value.engine_on.value ? makeTimeStamp(states.value.engine_on.value) : false
})

const engineOffTS = computed(() => {
    return states.value.engine_off.value !== null ? makeTimeStamp(states.value.engine_off.value) : false
})

const engineIsRunning = computed(() => {
    if(engineOnTS.value && engineOffTS.value) {
        return engineOffTS.value < engineOnTS.value
    } else if(!engineOnTS.value && engineOffTS.value) {
        return false
    } else if(engineOnTS.value && !engineOffTS.value) {
        return true
    }
    return true
})

// Манера вождения за поездку
const calcDriveAssessment = computed(() => {
    let result = {
        ride: null, 
        month: null
    }

    // За поездку
    const accelerationRide = states.value.trip_acceleration.value
    const brakingRide = states.value.trip_braking.value
    const mileageRide = states.value.ride_mileage.value

    // За месяц
    const accelerationMonth = tripMonth.value.acceleration.value
    const brakingMonth = tripMonth.value.braking.value
    const mileageMonth = tripMonth.value.mileage.value

    result.ride = driveAssessment(accelerationRide, brakingRide, mileageRide)
    result.month = driveAssessment(accelerationMonth, brakingMonth, mileageMonth)

    return result
})

// Расчёт расхода топлива
function calcFuelConsumption(mileage, fuel) {
    let result = '-'
    if(mileage == 0) {
        return result
    } else {
        if(mileage && fuel) {
            result = (fuel / (mileage * 10)).toFixed(1)
            if(result > 99.0) result = 99.9
            result += ' ' + getTranslate.value.UNIT_LITER_100_KM
        }
    }
    return result
}

// Средний расход топлива 
const fuelConsumption = computed(() => {

    let result = {
        ride: null, 
        month: null
    }

    // За поездку
    const mileageRide = states.value.ride_mileage.value
    const fuelRide = states.value.ride_fuel_consumption.value
    
    // За месяц
    const mileageMonth = tripMonth.value.mileage.value
    const fuelMonth = tripMonth.value.fuelConsumption.value
    
    result.ride = calcFuelConsumption(mileageRide, fuelRide)
    result.month = calcFuelConsumption(mileageMonth, fuelMonth)

    return result
})

// Расчёт средней скорости
function calcAverageSpeed(mileage, time) {
    let result = '-'
    if(mileage && time) {
        let m = Number(mileage),
            t = Number(time)
        if (m && t) {
            result = (m / (t / 3600)).toFixed(2).replace(/.$/, '') + ' ' + getTranslate.value.UNIT_KMH
        }
    }
    return result
}

// Средняя скорость
const averageSpeed = computed(() => {

    let result = {
        ride: null, 
        month: null
    }

    // За поездку
    const mileageRide = states.value.ride_mileage.value
    const timeRide = states.value.ride_time.value
    
    // За месяц
    const mileageMonth = tripMonth.value.mileage.value
    const timeMonth = tripMonth.value.time.value

    result.ride = calcAverageSpeed(mileageRide, timeRide)
    result.month = calcAverageSpeed(mileageMonth, timeMonth)

    return result
})

function buildTime(state) {

    if(state) {

        const value = state.value_text || state.value

        if(value && value !== null ) {

            const days      = value.days
            const hours     = value.hours
            const minutes   = value.minutes

            if(days == 0 && hours == 0 && minutes == 0) return `0 ${getTranslate.value.UNIT_MINUTE}`

            return `
                ${ days     ? days      + " " + getTranslate.value.UNIT_DAY       : "" } 
                ${ hours    ? hours     + " " + getTranslate.value.UNIT_HOUR      : "" } 
                ${ minutes  ? minutes   + " " + getTranslate.value.UNIT_MINUTE    : "" } 
            `
        }
    }

    return '–'
}

function buildValue(state) {

    if(state) {
        let value = state.value
        if(state.value !== null) {
            if(state.unit) {
                getTranslate.value[state.unit] ? 
                    value += ' ' + getTranslate.value[state.unit] :
                    value += ' ' + state.unit
            }
            return value
        }
    }

    return false
}

tripsCarStore.readTripMonth({ car: props.uuid })

</script>

<template>
    <div class="uta-car-states">

        <header class="page__header uta-header" role="heading" aria-level="1">
            <h2 class="uta-header__title">{{ getTranslate.CAR_STATES }}</h2>
        </header>

        <div class="page__content">
            <div class="uta-car-states__main">
                <div class="uta-car-info__props">
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-4">
                            <div class="uta-car-info__props-prop">
                                <div class="uta-car-info__props-prop-name">
                                    {{ getTranslate.STATE_STATUS }}
                                </div>
                                <div class="uta-car-info__props-prop-value">
                                    {{ buildValue(states.status) || '&mdash;' }}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4">
                            <div class="uta-car-info__props-prop">
                                <div class="uta-car-info__props-prop-name">
                                    {{ getTranslate.STATE_BATTERY_VOLTAGE }}
                                </div>
                                <div class="uta-car-info__props-prop-value">
                                    {{ buildValue(states.battery_voltage) || '&mdash;' }}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4">
                            <div class="uta-car-info__props-prop">
                                <div class="uta-car-info__props-prop-name">
                                    {{ getTranslate.STATE_COOLANT_TEMPERATURE }}
                                </div>
                                <div class="uta-car-info__props-prop-value">
                                    {{ buildValue(states.coolant_temperature) || '&mdash;' }}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4">
                            <div class="uta-car-info__props-prop">
                                <div class="uta-car-info__props-prop-name">
                                    {{ getTranslate.STATE_TEMPERATURE_OUTSIDE }}
                                </div>
                                <div class="uta-car-info__props-prop-value">
                                    {{ buildValue(states.temperature_outside) || '&mdash;' }}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4">
                            <div class="uta-car-info__props-prop">
                                <div class="uta-car-info__props-prop-name">
                                    {{ getTranslate.STATE_FUEL }}
                                </div>
                                <div class="uta-car-info__props-prop-value">
                                    {{ buildValue(states.fuel) || '&mdash;' }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="uta-car-states__group" id="statesLastTrip">

                <hr>
                <h3 class="mt-4 mb-4">{{ getTranslate.STATE_GROUP_LAST_TRIP }}</h3>

                <div class="row">

                    <!-- Последняя поездка -->
                    <div class="uta-car-states__groups-item col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 mb-4">
                        <div class="uta-car-states__groups-item-title">{{ getTranslate.STATE_COMMON_RIDE_TIME }}</div>
                        <div class="uta-car-states__groups-item-value" :title="buildTime(states.ride_time) || '&mdash;'">{{ buildTime(states.ride_time) || '&mdash;' }}</div>
                    </div>
                    <div class="uta-car-states__groups-item col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 mb-4">
                        <div class="uta-car-states__groups-item-title">{{ getTranslate.STATE_COMMON_MILEAGE }}</div>
                        <div class="uta-car-states__groups-item-value" :title="buildValue(states.ride_mileage) || '&mdash;'">{{ buildValue(states.ride_mileage) || '&mdash;' }}</div>
                    </div>
                    <div class="uta-car-states__groups-item col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 mb-4">
                        <div class="uta-car-states__groups-item-title">{{ getTranslate.STATE_COMMON_FUEL_CONSUMPTION }}</div>
                        <div class="uta-car-states__groups-item-value" :title="fuelConsumption.ride || '&mdash;'">{{ fuelConsumption.ride || '&mdash;' }}</div>
                    </div>
                    <div class="uta-car-states__groups-item col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 mb-4">
                        <div class="uta-car-states__groups-item-title">{{ getTranslate.STATE_COMMON_AVERAGE_SPEED }}</div>
                        <div class="uta-car-states__groups-item-value" :title="averageSpeed.ride || '&mdash;'">{{ averageSpeed.ride || '&mdash;' }}</div>
                    </div>
                    <!-- Оценка манеры вождения -->
                    <div class="uta-car-states__groups-item col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 mb-4">
                        <div class="uta-car-states__groups-item-title">{{ getTranslate.STATE_TRIP_DRIVING_ASSESSMENT }}</div>
                        <div class="uta-car-states__groups-item-value" :title="calcDriveAssessment.ride || '&mdash;'">{{ calcDriveAssessment.ride || '&mdash;' }}</div>
                    </div>
                    <!-- / Последняя поездка -->

                </div>

                <hr>
                <h3 class="mt-4 mb-4">{{ getTranslate.STATE_GROUP_LAST_MONTH }}</h3>

                <div class="row">

                    <!-- Статистика за месяц -->
                    <div class="uta-car-states__groups-item col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 mb-4">
                        <div class="uta-car-states__groups-item-title">{{ getTranslate.STATE_COMMON_RIDE_TIME }}</div>
                        <div class="uta-car-states__groups-item-value" :title="buildTime(tripMonth.time) || '&mdash;'">{{ buildTime(tripMonth.time) || '&mdash;' }}</div>
                    </div>
                    <div class="uta-car-states__groups-item col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 mb-4">
                        <div class="uta-car-states__groups-item-title">{{ getTranslate.STATE_COMMON_MILEAGE }}</div>
                        <div class="uta-car-states__groups-item-value" :title="buildValue(tripMonth.mileage) || '&mdash;'">{{ buildValue(tripMonth.mileage) || '&mdash;' }}</div>
                    </div>
                    <div class="uta-car-states__groups-item col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 mb-4">
                        <div class="uta-car-states__groups-item-title">{{ getTranslate.STATE_COMMON_FUEL_CONSUMPTION }}</div>
                        <div class="uta-car-states__groups-item-value" :title="fuelConsumption.month || '&mdash;'">{{ fuelConsumption.month || '&mdash;' }}</div>
                    </div>
                    <div class="uta-car-states__groups-item col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 mb-4">
                        <div class="uta-car-states__groups-item-title">{{ getTranslate.STATE_COMMON_AVERAGE_SPEED }}</div>
                        <div class="uta-car-states__groups-item-value" :title="averageSpeed.month || '&mdash;'">{{ averageSpeed.month || '&mdash;' }}</div>
                    </div>
                    <!-- Оценка манеры вождения -->
                    <div class="uta-car-states__groups-item col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 mb-4">
                        <div class="uta-car-states__groups-item-title">{{ getTranslate.STATE_TRIP_DRIVING_ASSESSMENT }}</div>
                        <div class="uta-car-states__groups-item-value" :title="calcDriveAssessment.month || '&mdash;'">{{ calcDriveAssessment.month || '&mdash;' }}</div>
                    </div>
                    <!-- / Статистика за месяц -->

                </div>

                <hr>
                <h3 class="mt-4 mb-4">{{ getTranslate.STATE_GROUP_LAST_EVENTS }}</h3>

                <div class="row">

                    <!-- Последние события-->
                    <div class="uta-car-states__groups-item col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 mb-4" v-if="engineIsRunning">
                        <div class="uta-car-states__groups-item-title">{{ getTranslate.STATE_ENGINE_ON }}</div>
                        <div class="uta-car-states__groups-item-value" :title="buildValue(states.engine_on) || '&mdash;'">{{ buildValue(states.engine_on) || '&mdash;' }}</div>
                    </div>
                    <div class="uta-car-states__groups-item col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 mb-4" v-else>
                        <div class="uta-car-states__groups-item-title">{{ getTranslate.STATE_ENGINE_OFF }}</div>
                        <div class="uta-car-states__groups-item-value" :title="buildValue(states.engine_off) || '&mdash;'">{{ buildValue(states.engine_off) || '&mdash;' }}</div>
                    </div>
                    <!-- <div class="uta-car-states__groups-item col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 mb-4" v-if="carIsMooving">
                        <div class="uta-car-states__groups-item-title">{{ getTranslate.STATE_START_MOVING }}</div>
                        <div class="uta-car-states__groups-item-value" :title="buildValue(states.start_moving) || '&mdash;'">{{ buildValue(states.start_moving) || '&mdash;' }}</div>
                    </div>
                    <div class="uta-car-states__groups-item col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 mb-4" v-else>
                        <div class="uta-car-states__groups-item-title">{{ getTranslate.STATE_STOP_MOVING }}</div>
                        <div class="uta-car-states__groups-item-value" :title="buildValue(states.stop_moving) || '&mdash;'">{{ buildValue(states.stop_moving) || '&mdash;' }}</div>
                    </div> -->
                    <!-- / Последние события -->

                </div>
            </div>

        </div>

    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/car/car-states.scss';
</style>